import React, { Component } from 'react';
import { connect } from 'react-redux';
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import TileData from "./TileData1";
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,accountsData}) {
  const {authUser} = auth
  const {isIamChild} = accountsData
  return {
    authUser,isIamChild
  };
}

function mapDispatchToProps(dispatch) {
  return {

  };
}

class index extends Component {
  state = {
    top: false,
    left: false,
    bottom: false,
    right: false
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  render() {
    const sideList = (
      <div className="drawer">
        <List>
          <TileData
          authUser={this.props.authUser}
          isIamChild={this.props.isIamChild}
          />
        </List>
      </div>
    );

   /* const fullList = (
      <div className="full-drawer">
        <List>{mailFolderListItems}</List>
      </div>
    );
  */
    return (
      <div>
        <div>
          <div
            styleName="col-lg-3 col-sm-6"
            cardStyle="text-center py-sm-5"
          >
            <Tooltip title={<IntlMessages id="DashBoard.View.Exchange"/>} aria-label="Växla vy">
              <Button
                variant="contained"
                className="jr-btn text-white bg-secondary"
                onClick={this.toggleDrawer("right", true)}
              >
                <i className="zmdi zmdi-long-arrow-left zmdi-hc-2x" />
              </Button>
            </Tooltip>
          </div>
        </div>

        <Drawer
          anchor="right"
          open={this.state.right}
          onClose={this.toggleDrawer("right", false)}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer("right", false)}
            onKeyDown={this.toggleDrawer("right", false)}
          >
            <div className="d-flex" style={{height: '51px', borderBottom:'1px #0c969c solid', backgroundColor:'#0c969c', color: 'white'}}>
              <div className="align-self-center mr-auto" style={{ marginLeft: '1rem', fontSize: 20 }}>
              <IntlMessages id="userProfile.Switch" />
              </div>
              <div className="align-self-center" style={{ marginRight: '10px' }}>
                <IconButton style={{color:'white'}} onClose={this.toggleDrawer("right", false)}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            {sideList}
          </div>
        </Drawer>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
)(index);